import { gql } from "@apollo/client";

export const GET_ALL_JOB_DAYS_FOR_DATE = gql`
    query jobDaysForForemanForDate($date: Date!) {
        jobDaysForForemanForDate(date: $date) {
            id
            job {
                name
                street1
                street2
                city
                state
                zipcode
            }
            date
            startTime
            endTime
            crewMemberAssignments {
                id
            }
        }
    }
`

// Job Day - Job Info
export const GET_JOB_DAY_BY_ID_WITH_JOB_INFO = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            job {
                id

                street1
                street2
                city
                state
                zipcode
                
            }
            scopeOfWork
            truck {
                number
            }
            driver {
                firstName
                lastName
            }
        }
    }
`

// Job Day - Job Info
export const GET_JOB_DAY_BY_ID_WITH_NAME_AND_DATE = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            date
            job {
                name
            }
        }
    }
`

export const GET_JOB_DAY_CREW_ASSIGNMENTS = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            date
            crewMemberAssignments {
                crewMember {
                    firstName
                    lastName
                    phone
                    classification
                }
                preliminaryApproval
            }
        }
    }
`

export const GET_JOB_DAY_BY_ID_FOR_SPLIT = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            job {
                name
                street1
                street2
                city
                state
                zipcode
            }
            date
            startTime
        }
    }
`

export const GET_JOB_DAY_BY_ID_FOR_SPLIT_ASSIGNMENTS = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            scopeOfWork
            crewMemberAssignments {
                id
                crewMember {
                    firstName
                    lastName
                    classification
                }
            }
        }
    }
`

export const GET_JOB_DAY_BY_ID_FOR_PROCESS_TIME_TICKETS = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            workType
            workType1
            workType2
            numFrames
            scopeOfWork
            safetyNotes
            customerSignature
            customerComments
            crewMemberAssignments {
                id
                crewMember {
                    firstName
                    lastName
                    classification
                }
                signOff {
                    signature
                }
                startTime
                endTime
                safetyAcknowledgment
            }
        }
    }
`

export const GET_JOB_DAY_BY_ID_JOB_INFO_FOR_PROCESS_TIME_TICKETS = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            job {
                name
                street1
                street2
                city
                state
                zipcode
                customerName
                customerContactName
                customerPhone
            }
            
        }
    }
`


export const GET_JOB_DAY_INFO_FOR_PDF = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id){
            id
            date
            safetyNotes
            scopeOfWork
            workType
            workType1
            workType2
            numFrames
            customerSignature
            customerComments
            job {
                name
                customerName
                customerPhone
                customerContactName
                street1
                street2
                city
                state
                zipcode
                wageRate
            }
            truck {
                number
            }
            driver {
                firstName
                lastName
            }
            crewMemberAssignments {
                crewMember {
                    firstName
                    lastName
                    classification
                }
                startTime
                endTime
                preliminaryApproval
                finalApproval
                isPaid
                paidDate
                signOff {
                    signature
                }
                jobDay {
                    date
                }
            }
        }
    }
`